export enum OPTIMIZELY_FLAGS_ENUM {
  WISHLIST_ENTRY_POINTS = 'guest_engagement_wishlist_v2',
  TMS_GATEWAY_PROXY_ENDPOINT = 'gtm_google_gateway_phase_2',
  THIRD_PARTY_ONBOARDING_MODAL = 'guest_engagement-auth_mfe-third_party_entry_modal',
}
